export default "__VITE_ASSET__CdnqHH8I__"